import { ENDPOINTS } from 'shared/constants/ENDPOINTS';
import { useAxios } from 'shared/hooks/useAxios';
import {
  IAuthorCreatePayload,
  IAuthorExportPayload,
  IAuthorRequestPayload,
  IAuthorResponsePayload,
  IAuthorUpdatePayload,
} from 'shared/interfaces/IAuthor';
import { transformPayload } from 'shared/utils/transformPayload';

const { GET, POST, DELETE } = useAxios();

export const useAuthorDao = () => {
  const getAuthors = async (payload?: IAuthorRequestPayload) => {
    const transformedPayload = transformPayload<IAuthorRequestPayload>(payload);

    const response = await GET<IAuthorResponsePayload>({
      url: ENDPOINTS.AUTHORS,
      params: {
        token: transformedPayload,
      },
    });

    return response.data;
  };

  const getSingleAuthor = async (id?: string) => {
    const transformedPayload = transformPayload({ _id: id, limit: 1 });

    const response = await GET<IAuthorResponsePayload>({
      url: `${ENDPOINTS.AUTHORS}/show`,
      params: {
        token: transformedPayload,
      },
    });

    return response.data;
  };

  const exportAuthors = async (payload?: IAuthorExportPayload) => {
    const transformedPayload = transformPayload(payload);

    const formData = new FormData();
    formData.append('token', transformedPayload);

    const response = await POST({
      url: `${ENDPOINTS.AUTHORS}/generate`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  };

  const createAuthor = async (payload?: { data?: IAuthorCreatePayload; avatar?: File }) => {
    const transformedPayload = transformPayload<IAuthorCreatePayload>(payload?.data);

    const formData = new FormData();
    formData.append('token', transformedPayload);
    if (payload?.avatar) formData.append('image', payload?.avatar);

    const response = await POST({
      url: `${ENDPOINTS.AUTHORS}/create`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  };

  const updateAuthor = async (payload?: { data?: IAuthorUpdatePayload; avatar?: File }) => {
    const transformedPayload = transformPayload<IAuthorUpdatePayload>(payload?.data);

    const formData = new FormData();
    formData.append('token', transformedPayload);
    if (payload?.avatar) formData.append('image', payload?.avatar);

    const response = await POST({
      url: `${ENDPOINTS.AUTHORS}/update`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  };

  const deleteAuthor = async (id: string) => {
    const transformedPayload = transformPayload({ _id: id });

    const response = await DELETE({
      url: `${ENDPOINTS.AUTHORS}/delete`,
      params: {
        token: transformedPayload,
      },
    });

    return response.data;
  };

  return {
    getAuthors,
    getSingleAuthor,
    createAuthor,
    updateAuthor,
    deleteAuthor,
    exportAuthors,
  };
};
